export default __webpack_public_path__ + "static/media/global-footprint-Header-HD.228c1566.jpg";